export const apiBaseURL = "https://oba.tracktrolley.com/oba-api";
export const zoomRange = 0.005;
export const apiKey = "org.onebusaway.iphone";
export const fetchInterval = 60 * 1000;
export const zoomBusOnlyCircle = 11.5;

export const msBaseUrl = "https://msapi.tracktrolley.com";
export const pbBaseUrl = "https://pbapi.tracktrolley.com";
export const bctBaseUrl = "https://bctapi.tracktrolley.com";

export const indigoColorForMiamiDade = "#6610f2";

export const linksObject = [
  {
    url: "https://sweetwater.tracktrolley.com",
    name: "Sweetwater",
    variant: "primary",
    color: "#0d6efd",
    disabled: false,
  },
  {
    url: "https://doral.tracktrolley.com",
    name: "Doral",
    variant: "info",
    color: "#0dcaf0",
    disabled: false,
  },
  {
    url: "https://comb.tracktrolley.com",
    name: "Miami Beach",
    variant: "success",
    color: "#198754",
    disabled: false,
  },
  {
    url: "https://fll.tracktrolley.com",
    name: "Fort Lauderdale",
    variant: "danger",
    color: "#dc3545",
    disabled: false,
  },
  {
    url: "https://ms.tracktrolley.com",
    name: "Miami Springs",
    variant: "warning",
    color: "#ffc107",
    disabled: false,
  },
  {
    url: "https://pb.tracktrolley.com",
    name: "Pompano Beach",
    variant: "secondary",
    color: "#6c757d",
    disabled: false,
  },
  {
    url: "https://bct.tracktrolley.com",
    name: "Broward County Transit",
    variant: "dark",
    color: "#212529",
    disabled: false,
  },
  {
    url: "#",
    name: "Miami-Dade",
    variant: "light",
    color: indigoColorForMiamiDade,
    disabled: true,
  },
];
